import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChurchLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C12.5128 2 12.9355 2.38604 12.9933 2.88338L13 3V4H14C14.5523 4 15 4.44772 15 5C15 5.51283 14.614 5.93551 14.1166 5.99327L14 6H13V7.5L16.6 10.2C16.8203 10.3653 16.9613 10.6128 16.9931 10.883L17 11V12.4648L19.5547 14.1679C19.7981 14.3302 19.9565 14.5895 19.9923 14.8758L20 15V20C20.5523 20 21 20.4477 21 21C21 21.5128 20.614 21.9355 20.1166 21.9933L20 22H4C3.44772 22 3 21.5523 3 21C3 20.4872 3.38604 20.0645 3.88338 20.0067L4 20V15C4 14.7074 4.12794 14.4318 4.34629 14.2432L4.4453 14.1679L7 12.4648V11C7 10.7246 7.11346 10.4633 7.31052 10.2757L7.4 10.2L11 7.5V6H10C9.44772 6 9 5.55228 9 5C9 4.48717 9.38604 4.06449 9.88338 4.00673L10 4H11V3C11 2.44772 11.4477 2 12 2ZM12 9.25L9 11.5V13C9 13.2926 8.87206 13.5682 8.65371 13.7568L8.5547 13.8321L6 15.5352V20H9V17C9 15.3431 10.3431 14 12 14C13.5977 14 14.9037 15.2489 14.9949 16.8237L15 17V20H18V15.5352L15.4453 13.8321C15.2019 13.6698 15.0435 13.4105 15.0077 13.1242L15 13V11.5L12 9.25ZM12 16C11.4872 16 11.0645 16.386 11.0067 16.8834L11 17V20H13V17L12.9933 16.8834C12.9355 16.386 12.5128 16 12 16Z",
		fill: "currentColor"
	})
});
export default SvgChurchLine;
